//
//
//
//
//
//
//
//
//
//
//

import { categoryConfig } from './config';
import Content from './content.vue';
export default {
  components: {
    Content: Content
  },
  data: function data() {
    return {
      categoryConfig: categoryConfig(this),
      // 1 普通消息  4 签字消息
      activeName: '1'
    };
  }
};